import React from "react";
import "../../assets/scss/app.scss";
import {BrowserRouter} from "react-router-dom";
import Auth from "../../assets/components/Auth";
import Navbar from "../../assets/components/Navbar/Navbar";
import {Container} from "react-bootstrap";
import Routes from "./Routes/Routes";
import LanguageDetector from "i18next-browser-languagedetector";
import {config as i18nextConfig} from "../../translations";
import {I18nextProvider} from "react-i18next";
import i18next from "i18next";
import {ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

i18next.use(LanguageDetector).init(i18nextConfig);

const App = (): JSX.Element => {
    return (
        <BrowserRouter>
            <I18nextProvider i18n={i18next}>
                <Auth>
                    <Navbar/>
                    <Container className="my-3">
                        <Routes/>
                        <ToastContainer
                            position="top-right"
                            autoClose={5000}
                            hideProgressBar={false}
                            newestOnTop={false}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                        />
                    </Container>
                </Auth>
            </I18nextProvider>
        </BrowserRouter>
    );
}

export default App;